export const Icon = () => {
    return (
        <svg width="84" height="84" viewBox="0 0 84 84" fill="none" stroke="#D4BC87">
            <rect x="17.5" y="38.5" width="49" height="35" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M24.5 28C24.5 18.335 32.335 10.5 42 10.5V10.5C51.665 10.5 59.5 18.335 59.5 28V38.5H24.5V28Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M42 59.5C43.933 59.5 45.5 57.933 45.5 56C45.5 54.067 43.933 52.5 42 52.5C40.067 52.5 38.5 54.067 38.5 56C38.5 57.933 40.067 59.5 42 59.5Z"
            />
        </svg>
    );
};
